import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { LanguageChoicePropType } from "web/types/language";
import { gettext } from "web/script/modules/django-i18n";
import { getURL } from "web/script/routing/getUrl";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import globals from "web/script/modules/globals";
import environment from "web/script/modules/environment";
import SubCategory from "./../main-navigation-subcategory/main-navigation-subcategory";
import styles from "./main-navigation-gender-menu.css";

function GenderMenu({
    currentCountry,
    currentCurrency,
    currentLanguage,
    menu,
    onCategoryClick,
    onCountrySelectorClick,
    onLanguageSelectorClick,
    showCountryPicker,
    showLanguageSelector,
    fullRender,
}) {
    const isRebrand = environment.getFeature("rebrand_2020");
    const iconName = isRebrand ? "arrow-icon" : "chevron";
    return (
        <>
            <div className={classnames(styles.genderMenu)}>
                {menu.menus &&
                    menu.menus.map((submenu) => {
                        const isSaleLink = submenu.name === "sale";
                        return (
                            <button
                                key={submenu.display_name}
                                className={classnames(styles.menuItem, {
                                    [styles.saleLink]: isSaleLink,
                                })}
                                type="button"
                                onClick={() => {
                                    if (isSaleLink) {
                                        globals.window.location.assign(submenu.url);
                                    } else {
                                        onCategoryClick(submenu);
                                    }
                                }}
                            >
                                {isSaleLink && (
                                    <SVGIcon
                                        className={classnames(styles.saleTag, styles.saleLink)}
                                        name="tag"
                                    />
                                )}
                                {submenu.display_name}
                                {!fullRender && !isSaleLink && (
                                    <SVGIcon className={styles.menuItemChevron} name={iconName} />
                                )}
                            </button>
                        );
                    })}
                {menu.links &&
                    menu.links.map((link) => (
                        <a key={link.url} className={styles.menuItem} href={link.url}>
                            {link.text}
                        </a>
                    ))}

                <button
                    type="button"
                    className={styles.menuItemBorderless}
                    onClick={onCountrySelectorClick}
                >
                    {gettext("burger_menu.country_selector", {
                        country: currentCountry,
                        currency_indicator: currentCurrency,
                    })}
                    {showCountryPicker && !isRebrand && (
                        <SVGIcon className={styles.menuItemChevron} name={iconName} />
                    )}
                </button>

                {showLanguageSelector && (
                    <button
                        type="button"
                        className={styles.menuItemBorderless}
                        onClick={onLanguageSelectorClick}
                    >
                        {gettext("burger_menu.language_selector", {
                            language: currentLanguage.language_name,
                        })}
                        <SVGIcon className={styles.menuItemChevron} name={iconName} />
                    </button>
                )}

                <a className={styles.menuItemBorderless} href={getURL("helpCentreHomepage")}>
                    {gettext("header.help.help_center")}
                </a>
                <a className={styles.menuItemBorderless} href={getURL("helpContactUs")}>
                    {gettext("header.help.contact_us")}
                </a>
                <a className={styles.menuItemBorderless} href={getURL("about")}>
                    {gettext("header.help.about_us")}
                </a>
                <a className={styles.menuItemBorderless} href={getURL("careers")}>
                    {gettext("header.help.careers")}
                </a>
            </div>

            {menu.menus &&
                menu.menus.map((submenu) => (
                    <SubCategory
                        key={submenu.display_name}
                        title={submenu.display_name}
                        submenu={submenu}
                        fullRender={fullRender}
                    />
                ))}
        </>
    );
}

GenderMenu.defaultProps = {
    currentCountry: "",
    currentCurrency: "",
    menu: [],
    showCountryPicker: false,
    showLanguageSelector: false,
    fullRender: false,
};

GenderMenu.propTypes = {
    menu: PropTypes.object,
    currentCountry: PropTypes.string,
    currentCurrency: PropTypes.string,
    currentLanguage: LanguageChoicePropType,
    onCategoryClick: PropTypes.func.isRequired,
    onCountrySelectorClick: PropTypes.func.isRequired,
    onLanguageSelectorClick: PropTypes.func.isRequired,
    showCountryPicker: PropTypes.bool,
    showLanguageSelector: PropTypes.bool,
    fullRender: PropTypes.bool,
};

export default GenderMenu;
